import api from './api';

class CoherentApi {
    static async terminalList(clinicId = null) {
        const url = clinicId ? `/coherence/terminals?clinicId=${clinicId}` : '/coherence/terminals';
        return api.request({
            method: 'GET',
            url
        });
    }

    static async terminalCheckout(data) {
        return api.request({
            method: 'POST',
            url: '/coherence/terminal-checkout',
            data
        });
    }

    static async checkPayment(id) {
        return api.request({
            method: 'GET',
            url: `/coherence/check-payment/${id}`
        });
    }

    static async clearTerminal(data) {
        return api.request({
            method: 'POST',
            url: '/coherence/clear-terminal',
            data
        });
    }

    static async getSavedCards(customerId, clinicId = null) {
        const params = clinicId ? `?clinicId=${clinicId}` : '';
        return api.request({
            method: 'GET',
            url: `/coherence/saved-cards/${customerId}${params}`
        });
    }

    static async debitSavedCard(data) {
        return api.request({
            method: 'POST',
            url: '/coherence/saved-card/debit',
            data
        });
    }
}

export default CoherentApi;
